module.exports = __webpack_public_path__ + "img/plan-basic.43ff9f22.svg";